<form novalidate #currentForm="ngForm">
  <div class="basic-field-group">
    <div class="basic-field-group-item--max-width">
      <div class="label">Name *</div>
      <div class="basic-field-group__input">
        <input
          autocomplete="off"
          class="text-input"
          placeholder="Enter application name"
          name="name"
          maxlength="30"
          [(ngModel)]="name"
          #nameInput="ngModel"
          (ngModelChange)="nameUpdated()"
          required
          [uniqueString]="names"
        />
        <i *ngIf="nameInput.valid" class="material-icons success-icon">done</i>
        <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
          <mat-error *ngIf="nameInput.errors.required">Name is required.</mat-error>
          <mat-error *ngIf="nameInput.errors.uniqueString">Name already exist.</mat-error>
        </div>
      </div>
    </div>
    <div class="app-logo" *ngIf="isCloudBased()">
      <logo-widget
        [serviceUrl]="url"
        [styleInfo]="'logo-48-wide'"
        [defaultUrl]="'default_app_icon'"
      ></logo-widget>
    </div>
  </div>
  <mat-slide-toggle
    [(ngModel)]="isChecked"
    [ngModelOptions]="{standalone: true}"
    [checked]="isChecked"
    (change)="resetURLvalues()"
    color="primary"
  >
    <span> URL with Auth </span>
  </mat-slide-toggle>
  <div class="basic-field-group" *ngIf="isCloudBased() && !isChecked">
    <div class="basic-field-group-item">
      <div class="label">URL *</div>
      <div class="basic-field-group__input">
        <input
          autocomplete="off"
          class="text-input"
          placeholder="Enter application URL"
          name="url"
          [(ngModel)]="url"
          #urlInput="ngModel"
          (ngModelChange)="urlUpdated()"
          required
          [uniqueUrl]="urls"
        />
        <i *ngIf="urlInput.valid && isValidUrl" class="material-icons success-icon">done</i>
        <div class="error" *ngIf="urlInput.invalid && (urlInput.dirty || urlInput.touched)">
          <mat-error *ngIf="urlInput.errors.required">URL is required.</mat-error>
          <mat-error *ngIf="urlInput.errors.uniqueUrl">URL already used.</mat-error>
        </div>
        <div class="error" *ngIf="urlInput.valid && !isValidUrl">
          <mat-error>{{urlValidationWarningMessage}}</mat-error>
        </div>
      </div>
    </div>
  </div>

  <div class="basic-field-group" *ngIf="isCloudBased() && isChecked">
    <div class="basic-field-group-item">
      <div class="label">URL with Auth</div>
      <div class="basic-field-group__input">
        <textarea
          autocomplete="off"
          class="text-input"
          placeholder="Enter the URL with auth"
          name="curlUrl"
          type="textArea"
          rows="20"
          cols="50"
          [(ngModel)]="curlUrl"
          #curlWithURLInput="ngModel"
          (ngModelChange)="curlwithURLUpdated()"
          required
        >
        </textarea>
      </div>
    </div>
  </div>
</form>
